import { Provider } from '@angular/core';
import {
    ErrorService,
    ParseService,
    RoleService,
    ShopOrderService,
    UserNotificationService,
    UserService,
} from '@w3booster/datamodel';

export const DATAMODEL_PROVIDERS: Provider[] = [
    {
        provide: ErrorService,
        useFactory: () => new ErrorService(),
    },
    {
        provide: ParseService,
        useFactory: (errorService: ErrorService) => new ParseService(errorService),
        deps: [ErrorService],
    },
    {
        provide: RoleService,
        useFactory: (errorService: ErrorService, parseService: ParseService) => new RoleService(errorService, parseService),
        deps: [ErrorService, ParseService],
    },
    {
        provide: ShopOrderService,
        useFactory: (errorService: ErrorService, parseService: ParseService) => new ShopOrderService(errorService, parseService),
        deps: [ErrorService, ParseService],
    },
    {
        provide: UserService,
        useFactory: (errorService: ErrorService, parseService: ParseService) => new UserService(errorService, parseService),
        deps: [ErrorService, ParseService],
    },
    {
        provide: UserNotificationService,
        useFactory: (errorService: ErrorService, parseService: ParseService) => new UserNotificationService(errorService, parseService),
        deps: [ErrorService, ParseService],
    },
];
